'use client';
import { ToggleGroup, ToggleGroupItem } from '@prenuvo/halo-web';
import { SkuDetails } from '@/components/ScanType';
import { useScanType } from '@/hooks';
import { getFilteredSkuOptions } from '@/utils/scanType';

export default function ScanType() {
  const { skus, selectedSku, locationId, isSlotsLoading, manageSkuChange } = useScanType();

  return (
    <>
      {skus.length > 1 && (
        <div className="section">
        <h2 className="section-title">Scan Type</h2>
        <p>Select type of scan</p>

        <div className="my-6">
          <ToggleGroup
          type="single"
          onValueChange={manageSkuChange}
          value={String(selectedSku?.skuID)}
          className="md:w-max [&>div]:w-full"
          >
          {getFilteredSkuOptions(locationId).map((sku, index) => (
            <ToggleGroupItem
            className="min-w-[120px] flex-none whitespace-normal break-words px-2 py-3 text-center md:whitespace-nowrap md:px-4 [&>span>span]:font-normal"
            key={index}
            label={{ children: sku.label }}
            value={String(sku.id)}
            disabled={!skus.find((s) => Number(s.skuID) === sku.id) || isSlotsLoading}
            />
          ))}
          </ToggleGroup>
        </div>

        </div>
      )}
      <SkuDetails />
    </>
  );
}
